import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { class: "row pb-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 fw-bold text-muted" }, "Tên danh mục", -1)
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-1 fw-bold text-muted" }, "Ngày tạo", -1)
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_9 = { class: "row pb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 fw-bold text-muted" }, "Mô tả:", -1)
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = { class: "row pb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 fw-bold text-muted" }, "Mã danh mục:", -1)
const _hoisted_14 = { class: "col-4" }
const _hoisted_15 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_16 = {
  key: 0,
  class: "row pb-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 fw-bold text-muted" }, "Danh mục cha:", -1)
const _hoisted_18 = { class: "col-4" }
const _hoisted_19 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_20 = { class: "row pb-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 fw-bold text-muted d-flex flex-row align-items-center" }, "Phân cấp cuối cùng:", -1)
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalThemToaXe = _resolveComponent("ModalThemToaXe")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!
  const _component_DinhMucCoDinhSection = _resolveComponent("DinhMucCoDinhSection")!
  const _component_DanhSachToaXe = _resolveComponent("DanhSachToaXe")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.danhMucToaXe)
      ? (_openBlock(), _createBlock(_component_ModalThemToaXe, {
          key: 0,
          "is-modal-open": _ctx.isModalOpen,
          "selected-toa-xe-items": _ctx.danhMucToaXe.toa_xe,
          "danh-muc-toa-xe-id": _ctx.danhMucToaXeId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalOpen = false)),
          onAdded: _ctx.onAddedToaXeItems
        }, null, 8, ["is-modal-open", "selected-toa-xe-items", "danh-muc-toa-xe-id", "onAdded"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmationDialog, {
      title: "Bạn có chắc chắn muốn xóa dữ liệu này?",
      width: "20%",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDeletingModalDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.danhMucToaXe)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.danhMucToaXe.ten_danh_muc), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_PageRowLayout, null, _createSlots({
      "page-row-header": _withCtx(() => [
        _createTextVNode(" Thông tin ")
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.EDIT,
          "color-type": _ctx.ButtonTypeColors.SUCCESS,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.push(`/quan-ly/danh-muc-toa-xe/${_ctx.danhMucToaXeId}/chinh-sua`)))
        }, null, 8, ["button-type", "color-type"]),
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.TRASH,
          "color-type": _ctx.ButtonTypeColors.DANGER,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDeletingModalDisplay = true))
        }, null, 8, ["button-type", "color-type"]),
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.BACK,
          onClick: _ctx.goBack
        }, null, 8, ["button-type", "onClick"])
      ]),
      _: 2
    }, [
      (_ctx.danhMucToaXe)
        ? {
            name: "page-row-content",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.danhMucToaXe.ten_danh_muc), 1)
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.moment(_ctx.danhMucToaXe.created_at).format('DD/MM/YYYY')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.danhMucToaXe)
                    ? (_openBlock(), _createBlock(_component_el_input, {
                        key: 0,
                        modelValue: _ctx.danhMucToaXe.mo_ta,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.danhMucToaXe.mo_ta) = $event)),
                        type: "textarea",
                        disabled: "",
                        rows: 3,
                        onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select()))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.danhMucToaXe.ma_danh_muc), 1)
                ])
              ]),
              (_ctx.danhMucToaXe.parent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.danhMucToaXe.parent.ten_danh_muc), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_checkbox, {
                    class: "mt-0",
                    disabled: "",
                    modelValue: _ctx.isPhanCapCuoiCung,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isPhanCapCuoiCung) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    (_ctx.danhMucToaXe)
      ? (_openBlock(), _createBlock(_component_DinhMucCoDinhSection, {
          key: 1,
          "dinh-muc-co-dinh-items": _ctx.danhMucToaXe.dinh_muc_co_dinh ? _ctx.danhMucToaXe.dinh_muc_co_dinh : [],
          "danh-muc-toa-xe-id": _ctx.danhMucToaXeId,
          onAdded: _ctx.fetchData
        }, null, 8, ["dinh-muc-co-dinh-items", "danh-muc-toa-xe-id", "onAdded"]))
      : _createCommentVNode("", true),
    (_ctx.danhMucToaXe && _ctx.danhMucToaXe && _ctx.danhMucToaXe.phan_cap === 1)
      ? (_openBlock(), _createBlock(_component_DanhSachToaXe, {
          key: 2,
          ref: "danhSachToaXeRef",
          "danh-muc-toa-xe-id": _ctx.danhMucToaXeId,
          "toa-xe-items": _ctx.danhMucToaXe.toa_xe,
          onOpenAddToaXeItemsModal: _ctx.openModal
        }, null, 8, ["danh-muc-toa-xe-id", "toa-xe-items", "onOpenAddToaXeItemsModal"]))
      : _createCommentVNode("", true)
  ], 64))
}